import React from "react";
import { LoginContext } from "@context/loginContext";
import Menu from "../Menu";
import logo from "../../../assets/logo.svg";
import logoDirecional from "../../../assets/LogoDirecional.png";
import logoRiva from "../../../assets/Rivalogo.png";
import { useAuth } from "src/routes";
import { useNavigate } from "react-router-dom";
import { capitalize } from "@helpers/format";
import { linkSidebar } from "@helpers/linkSidebar";
import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { UsuallyContext } from "@context/usuallyContex";
import { theme } from "src/styles/theme";
import { BiBell, BiUser, BiMenu, BiX } from "react-icons/bi";
import { SlOptionsVertical } from "react-icons/sl";
import DrawerNotification from "../DrawerNotification";
import DrawerUser from "../DrawerUser";
import notifyServiceInstance from "@services/Notify/notifyService";
import { OportunityContext } from "@context/oportunityContex";
import { cookieKeys, getCookie } from "@helpers/cookies";

const MenuSideBar = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    pageSidebar,
    setPageSidebar,
    notifications,
    setNotifications,
    isMarkedNotifications,
    setIsMarkedNotifications,
  } = React.useContext(LoginContext);
  const {
    setHashSalesSidebar,
    setHashDetailOportunity,
    setHashOportunity,
    setIsChatOpen,
  } = React.useContext(UsuallyContext);
  const { setAccessCreateOp, setFaseMyOportunity } =
    React.useContext(OportunityContext);
  const isAuthenticated = useAuth();
  const navigate = useNavigate();
  const user: any = localStorage.getItem("@user");
  const email = getCookie(cookieKeys.email) || "";
  const tipoDeUsuario: string | null = localStorage.getItem("@tipoDeUsuario");
  const [openUser, setOpenUser] = React.useState(false);

  // Estado para controlar abertura da sidebar no mobile
  const [isMobileOpen, setIsMobileOpen] = React.useState(false);

  // Fecha sidebar mobile ao navegar
  const closeMobileSidebar = React.useCallback(() => {
    setIsMobileOpen(false);
  }, []);

  const handleOptionClick = React.useCallback(
    (label: string) => {
      setPageSidebar(label);
      localStorage.setItem("@option", label);
      toast.closeAll();
    },
    [setPageSidebar, toast],
  );

  const handleClickImg = React.useCallback(
    (e: any) => {
      e.stopPropagation();
      setPageSidebar("Home");
      navigate("/");
      localStorage.setItem("@option", "Home");
      toast.closeAll();
      closeMobileSidebar();
    },
    [navigate, setPageSidebar, toast, closeMobileSidebar],
  );

  const handleNavigateOportunity = React.useCallback(
    (name: string) => {
      if (name?.toLowerCase() === "criar oportunidade") {
        setHashSalesSidebar("Oportunity");
      } else if (name?.toLowerCase() === "minhas oportunidades") {
        setHashSalesSidebar("MyOportunityComponent");
        setHashDetailOportunity("DetailOportunity");
        setFaseMyOportunity([]);
      } else {
        setHashSalesSidebar("");
      }
    },
    [setFaseMyOportunity, setHashDetailOportunity, setHashSalesSidebar],
  );

  const handleMarkDisplayed = React.useCallback(async () => {
    const idsNotificacaoNovaOp = notifications
      .filter((notification) => notification.tipoNotificacao === "NovaOP")
      .map((notification) => notification.id);

    const idsNotificacaoRetornoAC = notifications
      .filter((notification) => notification.tipoNotificacao === "RetornoAC")
      .map((notification) => notification.id);

    const idsNotificacaoRetornoCotacao = notifications
      .filter(
        (notification) => notification.tipoNotificacao === "RetornoCotacao",
      )
      .map((notification) => notification.id);
    const IdsNotificacaoTarefa = notifications
      .filter(
        (notification) => notification.tipoNotificacao === "VencimentoTarefa",
      )
      .map((notification) => notification.id);

    const data = {
      idsNotificacaoNovaOp,
      idsNotificacaoRetornoAC,
      idsNotificacaoRetornoCotacao,
      IdsNotificacaoTarefa,
    };

    try {
      const response = await notifyServiceInstance.markDisplayed(data);

      if (response?.status >= 400 && response?.status !== 401) {
        console.log("Erro ao marcar notificações como exibidas:", response);
        return;
      }

      if (response?.status === 401) {
        console.log("Usuário não autorizado:", response);
        setIsMarkedNotifications(false);
        return;
      }
    } catch (error) {
      console.error("Erro ao marcar notificações como exibidas:", error);
    }
  }, [notifications, setIsMarkedNotifications]);

  const handleNavigationSales = React.useCallback(() => {
    setHashOportunity("Oportunity");
    setHashSalesSidebar("Oportunity");
    setHashDetailOportunity("DetailOportunity");
    setAccessCreateOp({
      nomeDaConta: "",
      oportunidadeId: "",
      oportunityIdSalesforce: "",
    });
  }, [
    setHashDetailOportunity,
    setHashOportunity,
    setHashSalesSidebar,
    setAccessCreateOp,
  ]);

  const handleNavigationMyOportunity = React.useCallback(() => {
    setHashOportunity("MyOportunityComponent");
    setHashSalesSidebar("MyOportunityComponent");
    setHashDetailOportunity("DetailOportunity");
    setAccessCreateOp({
      nomeDaConta: "",
      oportunidadeId: "",
      oportunityIdSalesforce: "",
    });
  }, [
    setAccessCreateOp,
    setHashDetailOportunity,
    setHashOportunity,
    setHashSalesSidebar,
  ]);

  const handleNavigateMenu = React.useCallback(
    (label: string, to: string) => {
      closeMobileSidebar();

      if (label === "Notificações") {
        onOpen();
        handleMarkDisplayed();
      } else if (label === "Elô") {
        setIsChatOpen(true);
      } else if (label === "Criar oportunidade") {
        handleNavigationSales();
        handleOptionClick(label);
        navigate("/oportunidades");
        handleNavigateOportunity(label);
      } else if (label === "Minhas oportunidades") {
        handleNavigationMyOportunity();
        handleOptionClick(label);
        navigate("/oportunidades/minhas-oportunidades");
        handleNavigateOportunity(label);
      } else {
        handleOptionClick(label);
        navigate(to);
        handleNavigateOportunity(label);
      }
    },
    [
      handleNavigateOportunity,
      handleNavigationMyOportunity,
      handleNavigationSales,
      handleOptionClick,
      navigate,
      onOpen,
      handleMarkDisplayed,
      setIsChatOpen,
      closeMobileSidebar,
    ],
  );

  const truncateName = React.useCallback((name: string, maxLength: number) => {
    if (name?.length > maxLength) {
      return name?.slice(0, maxLength) + "...";
    } else return name;
  }, []);

  React.useLayoutEffect(() => {
    const storedOption: string | null = localStorage.getItem("@option");

    if (storedOption) {
      setPageSidebar(storedOption);
      handleNavigateOportunity(storedOption);
    }
  }, [
    setHashDetailOportunity,
    setHashSalesSidebar,
    setPageSidebar,
    handleNavigateOportunity,
  ]);

  // Fecha sidebar mobile ao pressionar Escape
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeMobileSidebar();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [closeMobileSidebar]);

  // Bloqueia scroll do body quando sidebar mobile está aberta
  React.useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileOpen]);

  if (!isAuthenticated) return null;

  return (
    <>
      <DrawerNotification
        isOpen={isOpen}
        onClose={onClose}
        notifications={notifications}
        setNotifications={setNotifications}
        setIsMarked={setIsMarkedNotifications}
      />

      <DrawerUser isOpen={openUser} onClose={() => setOpenUser(false)} />

      {/* ── Botão hambúrguer — visível apenas em mobile/tablet ── */}
      <Box
        display={{ base: "flex", lg: "none" }}
        pos="fixed"
        top={3}
        left={3}
        zIndex={1}
        as="button"
        aria-label={isMobileOpen ? "Fechar menu" : "Abrir menu"}
        onClick={() => setIsMobileOpen((prev) => !prev)}
        bg={theme.primary700}
        color="white"
        p={2}
        borderRadius="8px"
        boxShadow="md"
        transition="all 0.2s"
        _hover={{ opacity: 0.8 }}
        w={"fit-content"}
      >
        <Icon fontSize="22px" as={isMobileOpen ? BiX : BiMenu} />
      </Box>

      {/* ── Overlay — fecha a sidebar ao clicar fora (mobile) ── */}
      {isMobileOpen && (
        <Box
          display={{ base: "block", lg: "none" }}
          pos="fixed"
          inset={0}
          bg="blackAlpha.600"
          zIndex={998}
          onClick={closeMobileSidebar}
          aria-hidden
        />
      )}

      {/* Topbar mobile para evitar faixa branca */}
      <Box
        display={{ base: "block", lg: "none" }}
        position="fixed"
        top={0}
        left={0}
        right={0}
        height="100%"
        bg={theme.disable100}
      />

      {/* ── Sidebar ── */}
      <Flex
        pos="fixed"
        top={0}
        left={0}
        flexDir="column"
        h="100%"
        background={theme.primary700}
        zIndex={999}
        transition="width 0.25s ease, transform 0.25s ease"
        // Desktop: sempre visível com largura fixa
        // Mobile: desliza para dentro/fora
        w={{ base: "240px", lg: "230px" }}
        transform={{
          base: isMobileOpen ? "translateX(0)" : "translateX(-100%)",
          lg: "translateX(0)",
        }}
        boxShadow={{ base: isMobileOpen ? "2xl" : "none", lg: "none" }}
      >
        {/* ── Conteúdo da sidebar ── */}
        <Flex flexDir="column" w="100%" h="100%" overflow="hidden">
          {/* Header: Logo + Notificação */}
          <Flex
            p={3}
            justifyContent="space-between"
            alignItems="center"
            minH="60px"
          >
            {/* Logo */}
            <Box
              bg="whiteAlpha.200"
              display="flex"
              w="fit-content"
              p={2}
              borderRadius="8px"
              cursor="pointer"
              onClick={handleClickImg}
              _hover={{ bg: "whiteAlpha.300", transform: "scale(1.02)" }}
              transition="all 0.2s"
            >
              <Image
                src={logo || "/placeholder.svg"}
                alt="Logo"
                w="130px"
                h="auto"
              />
            </Box>

            {/* Ícone de Notificação */}
            <Box
              position="relative"
              w={"fit-content"}
              h={"fit-content"}
              onClick={() => {
                onOpen();
                handleMarkDisplayed();
              }}
              aria-label="Notificações"
            >
              <Icon
                cursor={"pointer"}
                fontSize="22px"
                color="white"
                as={BiBell}
                _hover={{ animation: "shake 0.5s" }} // Ativa a animação de balanço
              />

              {/* Badge de Notificação */}
              {isMarkedNotifications && (
                <Box
                  position="absolute"
                  top="-2px"
                  right="0px"
                  bg={theme.error}
                  w="10px"
                  h="10px"
                  borderRadius="full"
                  border="2px solid"
                  borderColor={theme.primary700}
                />
              )}
            </Box>
          </Flex>

          {/* Seção do Usuário */}
          <Flex
            px={2}
            py={2}
            gap={3}
            cursor="pointer"
            onClick={() => setOpenUser(true)}
            borderBottom="1px solid"
            borderColor="whiteAlpha.200"
            pb={4}
            _hover={{ bg: "whiteAlpha.100" }}
            transition="background 0.2s"
            borderRadius="6px"
            mx={1}
            mb={1}
            role="button"
            aria-label="Perfil do usuário"
          >
            {/* Avatar */}
            <Box
              display="flex"
              bg={theme.disable100}
              w="35px"
              h="35px"
              borderRadius="full"
              justifyContent="center"
              alignItems="center"
              flexShrink={0}
            >
              <BiUser fontSize="20px" />
            </Box>

            {/* Informações do Usuário */}
            <Flex
              flexDir="column"
              justifyContent="center"
              flex={1}
              minW={0}
              gap={1}
            >
              <Text
                fontSize="11px"
                color="white"
                noOfLines={1}
                title={capitalize(user)}
              >
                {truncateName(capitalize(user), 24)}
              </Text>
              <Text
                fontSize="10px"
                color="whiteAlpha.700"
                noOfLines={1}
                title={email}
              >
                {truncateName(email, 28)}
              </Text>
            </Flex>

            {/* Ícone de Opções */}
            <Flex
              alignItems="center"
              justifyContent="center"
              w="fit-content"
              flexShrink={0}
            >
              <Icon fontSize="14px" color="whiteAlpha.600">
                <SlOptionsVertical />
              </Icon>
            </Flex>
          </Flex>

          {/* Menu de Navegação */}
          <Flex
            flexDir="column"
            flex={1}
            px={2}
            py={3}
            gap={1}
            overflowY="auto"
            css={{
              "&::-webkit-scrollbar": { width: "4px" },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(255,255,255,0.2)",
                borderRadius: "2px",
              },
            }}
          >
            {linkSidebar
              .filter(({ label }) => {
                if (label === "Bolsão de oportunidades") {
                  const atividade: string =
                    localStorage.getItem("@atividade") ?? "";
                  return (
                    tipoDeUsuario === "Corretor" &&
                    !atividade?.toLowerCase()?.includes("imob")
                  );
                }
                return true;
              })
              .map(({ icon, iconSelected, label, to }) => {
                const isActive = pageSidebar === label;
                return (
                  <Box
                    key={label}
                    w="100%"
                    cursor="pointer"
                    role="menuitem"
                    aria-current={isActive ? "page" : undefined}
                    onClick={() => handleNavigateMenu(label, to)}
                  >
                    <Flex
                      w="100%"
                      minH="44px"
                      px={3}
                      py={2}
                      alignItems="center"
                      borderRadius="8px"
                      gap={3}
                      bg={isActive ? theme.backgroundPrimary : "transparent"}
                      _hover={{
                        bg: isActive
                          ? theme.backgroundPrimary
                          : "whiteAlpha.100",
                        transform: "translateX(4px)",
                      }}
                      transition="all 0.2s"
                    >
                      <Icon fontSize="18px" color="white" flexShrink={0}>
                        {isActive ? iconSelected : icon}
                      </Icon>

                      <Text
                        color="white"
                        fontSize={
                          label === "Bolsão de oportunidades" ? "11px" : "13px"
                        }
                        fontWeight={isActive ? "semibold" : "normal"}
                        flex={label === "Elô" ? undefined : 1}
                        w={label === "Elô" ? "fit-content" : undefined}
                        lineHeight="1.3"
                      >
                        {label}
                      </Text>

                      {label === "Elô" && (
                        <Text
                          color="#EF8D91"
                          fontSize="7px"
                          fontWeight="bold"
                          letterSpacing="0.05em"
                          w="fit-content"
                        >
                          NOVO
                        </Text>
                      )}
                    </Flex>
                  </Box>
                );
              })}
          </Flex>

          {/* Footer com Logos */}
          <Flex
            justifyContent="space-between"
            alignItems="center"
            px={4}
            py={4}
            borderTop="1px solid"
            borderColor="whiteAlpha.100"
          >
            <Image
              src={logoDirecional || "/placeholder.svg"}
              alt="Direcional"
              h="12px"
              w="auto"
              opacity={0.7}
            />
            <Image
              src={logoRiva || "/placeholder.svg"}
              alt="Riva"
              h="20px"
              w="auto"
              opacity={0.7}
            />
          </Flex>
        </Flex>
      </Flex>

      {/* Keyframe de shake para o sino */}
      <style>{`
        @keyframes shake {
          0%   { transform: rotate(0deg); }
          25%  { transform: rotate(-10deg); }
          50%  { transform: rotate(10deg); }
          75%  { transform: rotate(-10deg); }
          100% { transform: rotate(0deg); }
        }
      `}</style>
    </>
  );
};

export default React.memo(MenuSideBar);
